import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Popover } from '@/components/molecules/Popover'

import { formatDate } from '@utils/date'

interface IContestCreationConfirmationAlert {
  contestName?: string
  startDate?: number
  isOpen: boolean
  onDismiss: () => void
}

export const ContestCreationConfirmationAlert: FC<
  IContestCreationConfirmationAlert
> = ({ contestName = '', startDate = 0, isOpen, onDismiss }) => {
  const { t } = useTranslation('common')

  return (
    <Popover
      hasIcon={false}
      isOpen={isOpen}
      onDismiss={onDismiss}
      headerMessage={t('contest.confirmationAlert.header')}
      actionText={t('okay')}
      dismissOnSelect={true}
    >
      {t('contest.confirmationAlert.message', {
        contestName,
        startDate: formatDate(startDate),
      })}
    </Popover>
  )
}
